<template>
  <LayoutTriggerCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="onDeleteClick"
    @configure="onConfigureClick"
  >
    <template #icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="white"/>
        <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="white"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="scheduled-trigger-content">
        <!-- <div class="warning-message">
          <img src="@/assets/MyWorkBench/Workflow/warning_icon_triangel.svg" style="width: 20px; height: 20px; margin-right: 4px;" />
          <span class="warning-text">Required fields cannot be empty.</span>
        </div>

        <div class="form-field">
          <label class="field-label">
            Every <span class="required-mark">(Required)</span>
          </label>
          <div class="field-row">
            <input
              v-model="localFormData.frequencyValue"
              type="text"
              class="text-input"
              placeholder="Frequency"
              @input="updateSharedData"
            />
            <el-select
              v-model="localFormData.frequencyUnit"
              placeholder="Unit"
              class="unit-select"
              size="large"
              @change="updateSharedData"
            >
              <el-option label="Minutes" value="minutes" />
              <el-option label="Hours" value="hours" />
              <el-option label="Days" value="Days" />
              <el-option label="Weeks" value="Weeks" />
              <el-option label="Months" value="Months" />
            </el-select>
          </div>
        </div>

        <div class="form-field">
          <label class="field-label">Description</label>
          <TextareaWithClear
            v-model="localFormData.description"
            placeholder="Describe the scheduled workflow"
            :max-length="1000"
            :rows="4"
            @update:modelValue="updateSharedData"
          />
        </div> -->
              </div>

      <!-- Configured State -->
      <div v-else class="scheduled-trigger-configured">
        <div class="config-row">
          <span class="config-value">Schedule will be configured upon patient assignment.</span>
        </div>
      </div>
    </template>
  </LayoutTriggerCard>
</template>

<script>
import LayoutTriggerCard from './LayoutTriggerCard.vue';
import TextareaWithClear from '@/components/workflow/TextareaWithClear.vue';

export default {
  name: 'ScheduledTrigger',
  components: {
    LayoutTriggerCard,
    TextareaWithClear
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localFormData: {
        frequencyValue: this.data.frequencyValue || '',
        frequencyUnit: this.data.frequencyUnit || 'Weeks',
        description: this.data.description || ''
      },
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };
  },
  computed: {
    title() {
      return 'Scheduled';
    },
    subtitle() {
      return 'Runs on a schedule (daily, weekly, monthly)';
    },
    // Use savedData for display when available
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      return true;
    }
  },
  watch: {
    'data.frequencyValue': {
      handler(newVal) {
        if (newVal !== this.localFormData.frequencyValue) {
          this.localFormData.frequencyValue = newVal || '';
        }
      },
      immediate: true
    },
    'data.frequencyUnit': {
      handler(newVal) {
        if (newVal !== this.localFormData.frequencyUnit) {
          this.localFormData.frequencyUnit = newVal || 'Weeks';
        }
      },
      immediate: true
    },
    'data.description': {
      handler(newVal) {
        if (newVal !== this.localFormData.description) {
          this.localFormData.description = newVal || '';
        }
      },
      immediate: true
    }
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete');
    },
    onConfigureClick() {
      if (!this.isConfigureActive) return;
      
      this.$emit('configure', {
        frequencyValue: this.localFormData.frequencyValue,
        frequencyUnit: this.localFormData.frequencyUnit,
        description: this.localFormData.description
      });
    },
    updateSharedData() {
      // Update the shared data instance directly
      this.data.frequencyValue = this.localFormData.frequencyValue;
      this.data.frequencyUnit = this.localFormData.frequencyUnit;
      this.data.description = this.localFormData.description;
    }
  }
};
</script>

<style scoped>
.scheduled-trigger-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.warning-message {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

.warning-text {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
  flex: 1;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  display: flex;
  align-items: center;
  height: 24px;
}

.required-mark {
  color: #D10000;
  font-weight: 400;
}

.field-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.text-input {
  width: 146px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333333;
  outline: none;
  transition: border-color 0.2s ease;
}

.text-input:hover {
  border-color: #004879;
}

.text-input:focus {
  border-color: #004879;
  outline: none;
}

.text-input::placeholder {
  color: #999999;
}

.time-select {
  flex: 1.5 0 0;
}

.unit-select {
  flex: 1.5 0 0;
}

:deep(.el-select .el-input .el-input__wrapper) {
  border-radius: 6px;
  border: 1px solid #d0d0d0;
  min-height: 40px;
  box-shadow: none;
}

:deep(.el-select .el-input .el-input__wrapper:hover) {
  border-color: #1890ff;
}

:deep(.el-select .el-input .el-input__wrapper.is-focus) {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

:deep(.el-select .el-input__inner) {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 14px;
  color: #4a4a4a;
}

.textarea-container {
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: border-color 0.2s ease;
}

.textarea-container:focus-within {
  border-color: #004879;
}

.trigger-textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333333;
  min-height: 90px;
}

.trigger-textarea:focus {
  outline: none;
}

.trigger-textarea::placeholder {
  color: #999999;
}

.textarea-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.character-count {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #999999;
  flex: 1;
}

.clear-button {
  padding: 4px 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  transition: opacity 0.2s ease;
}

.clear-button:hover {
  opacity: 0.8;
}

.scheduled-trigger-configured {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.config-row {
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
}

.config-label {
  font-weight: 700;
  color: #374957;
}

.config-value {
  font-weight: 400;
}

.starting-date-picker {
  width: 160px;
}


</style>
